<template>
  <div class="overflow-hidden"  >
    <a-spin :spinning="spinnings" tip="資料載中...">
    <div class="d-flex flex-column min-vh-100">
    <van-notify v-model="visible" :type="mType">
      <div  style="padding:0.5rem;color:white;font-weight: bold;font-size: 20px;text-align: left;"  v-html="answer"></div>
    </van-notify>     
    <a-drawer
      placement="right"
      :closable="false"
      :visible="display"
      @close="onClose"
    >
      <a-card :title="cardtitle" :bordered="false">
          <a-button slot="extra" type="primary" @click="onClose" shape="round">關閉</a-button>
          <div v-html="cardcontent"></div> 
      </a-card>
    </a-drawer>                   
    <div class="mt-3" >
        
      <a-calendar @select="onSelect" @panelChange="onChangeDate" :fullscreen="true" :defaultValue="currentTime" :locale="locale"  :style="{ height:'49.8rem' ,border: '1px solid #d9d9d9', borderRadius: '4px' }" class="overflow-hidden" >
          <div slot="dateCellRender" slot-scope="value" class="events" style="overflow-x: hidden;overflow-y:hidden;">
            <div v-for="item  in getListData(value)" :key="item.content"  >
              <div class="notes" :style="{'background-image': item.type==='Y'?'linear-gradient(to bottom, #c5ddf8, #3386e7)':'linear-gradient(to bottom, #dbdedb, #aeb1ae)','cursor':'pointer'}">   
                <b-icon :icon=" item.type==='Y'? 'flag-fill':'clock-history'" style="margin-top:1.2rem;color:aliceblue;" font-scale="2"></b-icon>
                <div class="status-text" :class="{'active': item.type==='Y'}">
                  {{ item.type==='Y' ? '活動中' : '已結束' }}
                </div>                           
              </div>
            </div>
          </div>  
          <template slot="monthCellRender" slot-scope="value">
              <div v-if="getMonthData(value)" class="notes-month">
              <section>{{ getMonthData(value) }}</section>
              <span>Backlog number</span>
              </div>
          </template>
      </a-calendar>                  
    </div>  
    <Acbottommenu @savelove="savelove" @scanCode="scanCode" @toLocal="toLocal" ref="con3" />      
    </div>
      <van-popup
          v-model="showActivityPopup"
          closeable
          :close-on-click-overlay="false"
          position="top"
          :style="{ width: '100%', maxHeight: '100%', overflow: 'auto',borderRadius: '0 0 16px 16px' }"
        >
      <div class="popup-header">
        <div class="popup-title">{{ mytitle }}</div>
      </div>        
        <div class="text-center" style="padding:5px;margin-top: 1rem;">
                <div v-if="!list" @click="toclose()" style="cursor: pointer">                
                <div class="qrheader">
                  <span v-text="'關閉QRCoder 請直接點選圖片'"  />
                </div>
                <div class="qrbody">
                  <vue-qr
                      ref="qrCode"
                      :text="textValue"
                      :logoScale="40" 
                      :size="350" 
                      :margin="10"
                  />
                </div> 
                </div>
                <div v-if="list">
                    <div
                      v-for="(item, $index) in information"
                      :key="$index"      
                    >

                        <van-cell-group inset class="custom-cell-group">
                          <van-cell 
                            :title="rename(item.actitle)" 
                            :label="'時間: ' + converts(item.sdate, item.edate)"
                            class="activity-cell"
                          >
                            <!-- 自定義右側內容 -->
                            <template #right-icon>
                              <div class="status-tag-wrapper">
                                <van-tag 
                                  :type="item.states=='Y' ? 'success' : 'warning'" 
                                  round
                                  class="custom-status-tag"
                                  :class="{'status-completed': item.states=='Y', 'status-pending': item.states!=='Y'}"
                                >
                                  <van-icon :name="item.states=='Y' ? 'checked' : 'clock-o'" class="status-icon" />
                                  {{ item.states=='Y' ? '已報到' : '未報到' }}
                                </van-tag>
                              </div>
                            </template>
                            
                            <!-- 自定義下方按鈕區域 -->
                            <template #label>
                              <div class="cell-time">
                                <van-icon name="clock-o" /> {{ converts(item.sdate, item.edate) }}
                              </div>
                              <div class="cell-actions">
                                <van-button 
                                  type="primary" 
                                  size="normal" 
                                  icon="description" 
                                  @click="toConten(item.fid)"
                                  class="custom-button details-button"
                                >詳情</van-button>
                                
                                <van-button 
                                  v-if="item.states!=='Y' && item.sdate > fdateformat(currentTime)"
                                  type="danger" 
                                  size="normal" 
                                  icon="delete" 
                                  @click="delItem(item, item.roles)"
                                  class="custom-button delete-button"
                                >刪除</van-button>
                              </div>
                            </template>
                          </van-cell>
                        </van-cell-group>
                    </div>                    
                </div>                
        </div>
      </van-popup>   
    </a-spin>  
    
  <a-drawer
    :visible="applyDrawerVisible"
    :closable="true"
    placement="bottom"
    height="92vh"
    :body-style="{ padding: 0, overflowY: 'auto', height: '100%' }"
    :header-style="{ background: '#d9dad9', color: '#fff' }"
    title="活動詳情"
    @close="applyDrawerVisible = false"
    :z-index="9950"
  >
    <a-spin :spinning="applyLoading" tip="資料載入中..." style="display:flex; align-items:center; justify-content:center; min-height:100%;">
      <Inforact v-if="applyObj !== null" :obj="applyObj" />
    </a-spin>
  </a-drawer>    
  </div>
</template>

<script>
import { joinService,actService,macService } from '../_services'
import { mapState,mapMutations } from "vuex";
import * as moment from "moment/moment";
import MY_JSON from '../assets/json/optiondata.json'
import VueQr from 'vue-qr'
import router from '../router'
import 'moment/locale/zh-tw';
import logoImg from '@/assets/lineicon.svg'
import Acbottommenu from '../myline/panel/Acbottommenu.vue'
import { mixinWebsocket } from '../wsocket/wsobj.js';
import store from "../store/index"
import Inforact from "@/myline/apply/Inforact.vue";
import { Cell, CellGroup, Tag, Icon, Button } from 'vant';



const deleteItemam = params => {
  return actService.delMan(params.id, params.aid, params.fid, params.uid, params.roles);
};

const findall = obj => {
  return joinService.singmydate(obj) 
};


export default {
  name: 'Mydoing',
  mixins: [mixinWebsocket],  
  components: {
    VueQr,
    Inforact,
    Acbottommenu,
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanTag: Tag,
    VanIcon: Icon,
    VanButton: Button
  },
  props: {
    msg: String
  },
  data() {
    return {
      myJson: MY_JSON, 
      mType: 'primary',
      showActivityPopup: false, // 新增控制彈窗顯示的變量  
      spinnings: false,     
      showTop: false,                 
      message:'',
      currentTime:moment(),
      myDates:moment(),
      mytitle:'',
      returndata:[],
      information:[],
      logoPath:logoImg,
      textValue:'',
      list:true,
      visible:false,
      display:false,
      notifyTimer: null,
      answer:'',  
      cardtitle:'', 
      cardcontent:'',
      applyDrawerVisible: false,
      applyObj: null,
      applyLoading: false,      
      locale:{
        lang:{
          month:'月',
          year:'年',
        }
      },          
    };
  },  
  async mounted(){
    this.myDates = this.getdate(this.myDates)
    if(this.user!==null){
        let obj= {id:'Myline'}
        await this.setorgpage(obj).then((val)=>{return val}).catch((val)=>{return val}).finally(() => {console.log('set page done')})   
        let names = store.state.account.targetpage
        if(names=='Myline'){  
          this.getLinecheck()
          if(this.linecheck==true){
            this.getfetchall({id:this.user.data.user.id,myDate:this.myDates})
            this.initWebsocket();
          }        
        }              
    }  
  },
  computed: {
    ...mapState("account", ["user", "user","linecheck"]),
    ...mapState("ws", ["wsNotify","wsState","socket"]),  
  }, 
  watch: {    
    wsNotify(val){
        if(typeof val === 'object' && val !== null){
            if(val.data.type==='order'){ 
                this.showActivityPopup =false; 
                let mKind = 'primary';
                if(val.data.title.includes('<p>報名|報到(失敗)</p>')){
                  mKind = 'danger'
                }else{
                  mKind = 'primary'
                  this.getfetchall({id:this.user.data.user.id,myDate:this.myDates})
                }
                  let tmp = `
                      <div style="text-align:left; !important;">
                        ${val.data.title}${val.data.rmg}
                      </div>
                  `;
                this.showNotify(tmp,mKind);                                  
            }
        }
    },

    socket(val){
      if(val!==null){
        if(val.url==undefined){ 
          this.initWebsocket();
        }
      }
    }    

  },      
  methods: {   
    ...mapMutations('account',['setpage','getLinecheck']),       
    query(rs){
      this.classtheme = rs
    }, 

    savelove(val) {
        if (val == "home") {
          router.replace({ name: "Myline" });
        }   
    },     
    fdateformates(val) {
      return (
        moment(val.sdate).format("YYYY-MM-DD HH:mm") +
        "~" +
        moment(val.edate).format("HH:mm")
      );
    },    
    getfetchall(params = {}) {
      this.spinnings=true
      findall({
        ...params,
      }).then(({ data }) => { 
          this.spinnings=false         
          this.returndata = data;
      });
    }, 
    delItem(items,roles) {
      const self = this;
      this.$confirm({
        title:
          "您確定要刪除該課程?",
        content: "活動名稱 : " + items.actitle + '|時間:'+items.sdate,
        okText: "Yes",
        okType: "danger",
        cancelText: "No",
        zIndex: 9999,
        async onOk() {
          await self.removem(items,roles);
        },
        onCancel() {
          console.log("Cancel");
        }
      });
    },  

    rename(value){
      return value.length >= 15 ? value.substring(0,10)+'...':value
    },  
    
    converts(v1,v2){
      return moment(v1).format("YYYY-MM-DD HH:mm") +'~'+ moment(v2).format("HH:mm");
    },    
    
    async removem(items,roles) {
      await deleteItemam({ id: items.cid, aid: items.aid,fid:items.fid,uid: items.uid,roles }).then(
        ({ data }) => {
          data.code == 200
            ? this.getfetchall({id:this.user.data.user.id,myDate:this.myDates})
            : this.$message.warning("刪除發生錯誤");
            this.showActivityPopup = false; // 關閉彈窗
        }
      );
    },    
    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },
    getdate(val){
        return moment(val).format("YYYY-MM-DD"); 
    },    
    toNext(){
      router.replace({ name: 'Myline'})
      //router.go(-1)
    },

    getinfo(theme){
        let url = this.myJson.find(rs=>rs.value==theme).title
        return url
    },
    
    toQrcode(val){
      this.list=false
      let tmp = val.id+","+val.sdate+" "+val.stime+","+val.edate+" "+val.etime+","+val.aid+","+val.fid+","+val.uid
      this.textValue = tmp
    },

    setorgpage(obj){
          return new Promise((resolve)=>{  
            resolve(this.setpage(obj))            
          })          
    },    

    toclose(){
      this.list=true
    },
    
    getListData(value) {
      let listData=[];
      if(this.returndata!==null){
      this.returndata.forEach((item)=>{          
          if(this.getdate(item.sdate) == value.format("YYYY-MM-DD")){
              listData.push(
                  {
                    type: this.getdate(item.sdate) >=this.currentTime.format("YYYY-MM-DD")?'Y':'N',
                    id:item.id,
                    aid:item.aid,
                    fid:item.fid,   
                    uid:item.uid,         
                    orgid:item.orgid,       
                    url:item.url,           
                    actitle:item.actitle,          
                    sdate:item.sdate,         
                    edate:item.edate,
                    stime: item.stime,
                    etime: item.etime,                     
                    state:item.states                                                                                           
                }
              )
          }            
          });
          return listData || [];
      }
      return listData || [];

    },

    async toConten(id) {
      this.applyObj = null;
      this.applyDrawerVisible = true;
      this.applyLoading = true;
      try {
        const { data } = await macService.macfind(id);
        this.applyObj = data;
      } catch (e) {
        console.error(e);
      } finally {
        this.applyLoading = false;
      }
    },    

    showNotify(msg, types, duration = 3500) {
      this.answer = msg;
      this.visible = true;
      this.mType = types;
      if (this.notifyTimer) clearTimeout(this.notifyTimer);
      this.notifyTimer = setTimeout(() => {
        this.answer = '';
        this.visible = false;
        this.mType = 'primary';
        this.notifyTimer = null;
      }, duration);
    },    

    onSelect(e){
      this.mytitle='我的活動資訊'+ moment(e).format("YYYY-MM-DD")
      this.information = this.returndata.filter(rs=>this.getdate(rs.sdate)==moment(e).format("YYYY-MM-DD"))
      if(this.information.length>0){
          this.list=true
          this.showActivityPopup = true; // 顯示彈窗 
      }else{
        this.showNotify("無資料!",'warning');                 
      }


    },

    onChangeDate(e){
      this.myDates = this.getdate(e._d)
      this.getfetchall({id:this.user.data.user.id,myDate:this.myDates})  
    },

    getMonthData(value) {
      if (value.month() === 8) {
        return 1394;
      }
    }, 

    scanCode(val){

        if(val.code=="308"){
          this.$confirm({
            title: "您尚未報名，請線上填寫報名表",
            content: "是否前往報名？",
            okText: "前往報名",
            cancelText: "取消",
            zIndex: 9999,
            onOk: () => {
              this.toConten(val.fid);
            },
            onCancel: () => {
              // 什麼都不用做，視窗自動關閉
            }
          });
          return;
        }
        let type="success"    
        let value = '報到失敗 :' + '<br/>'
        if(val.code=="200"){
          value =  '報到成功 :' + '<br/>' 
          this.getfetchall({id:this.user.data.user.id,myDate:this.myDates})
        }else if(val.code=="208"){
           value = '報到失敗(活動已額滿) ' + '<br/>'
           type = 'warning'
        }else if(val.code=="209"){
           value = '報名成功 ' + '<br/>' 
           this.getfetchall({id:this.user.data.user.id,myDate:this.myDates})  
           type = 'success'        
        }else if(val.code=="300"){
           value = '重複報到 ' + '<br/>'
           type = 'warning'    
        }else if(val.code=="301"){
           value = '重複報名 ' + '<br/>'  
           type = 'warning'            
        }else if(val.code=="303"){
           value = '代碼錯誤 ' + '<br/>'
           type = 'danger'   
        }else if(val.code=="304"){
           value = '報到失敗 ' + '<br/>'  
           type = 'danger'          
        }else if(val.code=="400"){
           value = '請確認活動日期 ' + '<br/>'
           type = 'warning'
        }else if(val.code=="401"){
           value = '活動尚未開始, 請確認日期 ' + '<br/>'
           type = 'primary'
        }else if(val.code=="402"){
           value = '活動已經結束, 謝謝  ' + '<br/>'
           type = 'primary'
        }else if(val.code=="500"){
           value = '系統錯誤, 請稍後再試 ' + '<br/>'
           type = 'danger' 
        }
        this.mType = type;
        this.showNotify(value,type);         
    },    
    
    scanCode1(val){ //沒用到的Function
        let value = this.validation(val)
        this.showNotify(value,'primary');             
    },  
    
    validation(val){  //沒用到的Function
      let tmp = '資料不符 : <br/>' + val
      if(val!==""){
        if(val.substring(0, 7)==='actjoin'){          
          let strAry = val.split(',');
          if(strAry.length==6){
            let obj ={
            id: strAry[0],
            sdate: strAry[1],
            edate: strAry[2],
            aid: strAry[3],
            fid: strAry[4],
            uid: strAry[5],
          }
          tmp = '資料正確 : <br/>' + obj
          }
        }
      }
      return tmp
    },
    
    onHide(evt) {
          if(evt.trigger === "backdrop"){
              evt.preventDefault();
          }
      },
      
    onClose() {
      this.display = false;
    }, 
    
    toLocal(val){
      //console.log('latitude:', val);
      this.cardtitle="我的位置"
      this.cardcontent=val
      this.display = true;         
    },    
  },    
}
</script>
<style scoped>
  img {
    max-width: 100%;
    min-height: 100%;
    object-fit: cover;
    display: block;
    clip-path: polygon(-4px -4px, 100.4% -3px, 99.2% 102.57%, -0.8% 102.97%);
  }

  .cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    width: min(98%, 500px);
    margin: 0 auto;
    box-shadow: 0 20px 34px hsla(20deg, 1%, 52%, 0.29);
    overflow: hidden;
  }

  .cards-details {
    text-align: left;
    position: relative;
    padding: 0 0.05rem 0 0.5rem;
  }  

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.fontstyle{
   font-size:0.8rem;
   color:#faf8f8;
}

.fontstyle2 {
font-size: 0.93rem;
font-weight:bold;
color: #2c055e;
padding: 0.4rem;
background:linear-gradient(45deg,#7fdac1 0%,#5decde 60%,#ddf0e6 60%,#93cea2 100%);
opacity:0.85;
}

.notes{
  position: absolute;
  border-radius: 15px;
  top: 25%;
  left: 0;
  width: 80%;
  height: 70%;
  text-align: center; /* 文本水平居中 */
  vertical-align: middle; 
  cursor:pointer;
  }

.qrbody{
    padding:0.4rem;
    background-color: #76d27a;
    color:white;
    border-radius:0 0 0.5rem 0.5rem;
    border-bottom-style: dotted;
    border-width:0.35rem;
    border-left-style: dotted;
    border-right-style: dotted; 
}

.qrheader{
  padding:0.5rem;
  background-color: #6dc871;
  color:white;
  border-radius:1.3rem 1.3rem 0 0;
  border-bottom-style: dotted;
  border-width:0.20rem;
}
.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

.card-body{
  padding:0px;
}

.card-img-top{
  border-top-right-radius:25px;
}
.card{
  border-top-right-radius:25px;
}
.status-text {
  color: white;
  font-size: 0.8rem;
  font-weight: bold;
  margin-top: 0.3rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.status-text.active {
  color: #ffffff;
}
/* 活動單元格組樣式 */
.custom-cell-group {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, 
              rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, 
              rgba(0, 0, 0, 0.07) 0px 16px 16px;
}

/* 活動單元格樣式 */
.activity-cell {
  padding: 16px;
}

/* 時間信息樣式 */
.cell-time {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.cell-time .van-icon {
  margin-right: 4px;
  color: #1989fa;
}

/* 按鈕區域樣式 */
.cell-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #ebeef5;
}

/* 自定義按鈕基本樣式 */
.custom-button {
  flex: 1;
  height: 40px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  border-radius: 8px !important;
  margin: 0 4px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
}

/* 詳情按鈕特定樣式 */
.details-button {
  background: linear-gradient(to right, #4facfe, #5eb3fd) !important;
  border: none !important;
}

/* 刪除按鈕特定樣式 */
.delete-button {
  background: linear-gradient(to right, #ff5858, #fa6b6b) !important;
  border: none !important;
}

/* 懸停效果 */
.custom-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

/* 活動按鈕圖標樣式 */
.custom-button :deep(.van-icon) {
  font-size: 16px !important;
  vertical-align: -3px !important;
  margin-right: 4px !important;
}

/* 狀態標籤包裝容器 */
.status-tag-wrapper {
  display: flex;
  align-items: center;
}

/* 自定義狀態標籤基本樣式 */
.custom-status-tag {
  padding: 8px 12px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  border-radius: 16px !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12) !important;
  display: flex !important;
  align-items: center !important;
  white-space: nowrap !important;
}

/* 已報到標籤樣式 */
.status-completed {
  background: linear-gradient(to right, #07c160, #42d680) !important;
  border: none !important;
  color: white !important;
}

/* 未報到標籤樣式 */
.status-pending {
  background: linear-gradient(to right, #ff976a, #ffb090) !important;
  border: none !important;
  color: white !important;
}

/* 標籤內的圖標樣式 */
.status-icon {
  margin-right: 4px;
  font-size: 16px;
}

/* 覆蓋 Vant 標籤默認樣式 */
:deep(.van-tag) {
  line-height: 1.2 !important;
}

/* 自定義 Vant 樣式 */
:deep(.van-cell__title) {
  flex: 4;
  font-weight: bold;
  font-size: 16px;
  color: #2c055e;
}

:deep(.van-tag--success) {
  background-color: #07c160;
}

:deep(.van-tag--warning) {
  background-color: #ff976a;
}
.popup-header {
  padding: 16px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  border-bottom: 1px solid #ebedf0;
  color: #323233;
}

.popup-content {
  padding: 16px;
}
/* 在 <style> 部分添加 */
:deep(.custom-notify) {
  font-size: 16px;
  font-weight: bold;
  padding: 12px 20px;
  z-index: 3000; /* 確保在最上層 */
}
</style>
<style >
  .ant-fullcalendar-content{
  overflow-y: hidden;
  overflow-x: hidden;
  }
  .ant-fullcalendar-header .ant-radio-group {
    display: none !important;
  }

  /* 增大年份選擇器 */
  .ant-fullcalendar-header .ant-select {
    font-size: 20px !important;
  }
  
  /* 增大下拉選單容器 */
  .ant-fullcalendar-header .ant-select-selection {
    height: 38px !important;
    padding: 4px 12px !important;
  }
  
  /* 調整選中文字的位置 */
  .ant-fullcalendar-header .ant-select-selection__rendered {
    line-height: 30px !important;
  }
  
  /* 增大下拉箭頭 */
  .ant-fullcalendar-header .ant-select-arrow {
    font-size: 14px !important;
    right: 12px !important;
  }
  
  /* 增大下拉選單中的選項 */
  .ant-select-dropdown-menu-item {
    padding: 10px 12px !important;
    font-size: 20px !important;
  }
  
  /* 調整標題間距，使其更協調 */
  .ant-fullcalendar-header {
    padding: 16px 12px !important;
  }
  
  /* 保持年月選擇器間的間距 */
  .ant-fullcalendar-header .ant-select + .ant-select {
    margin-left: 18px !important;
  }  
  :deep(.van-popup) {
  border-radius: 0 !important;
}
</style>